export const FONT_SIZE = 12;
export const DEFAULT_INPUT_WIDTH = 20;
